/* TPL Splash V2 — ASCII Tower + Lighthouse Beams
   One-shot, ~6s on first visit. Skipped on second visit (sessionStorage)
   or for prefers-reduced-motion users. Dispatches `tpl-splash-done`
   with { skipped: bool } so the hero video knows to start.
   Tower JSON is read from window.TPL_TOWER (inlined by the snippet). */

(function () {
  'use strict';

  var splash = document.getElementById('tpl-splash');
  if (!splash) return;
  window.tplSplash = window.tplSplash || { done: false };

  function dispatchDone(detail) {
    document.dispatchEvent(new CustomEvent('tpl-splash-done', { detail: detail || {} }));
  }

  function dismissImmediate(skipped) {
    window.tplSplash.done = true;
    try { sessionStorage.setItem('tpl-splash-seen', '1'); } catch (e) {}
    dispatchDone({ skipped: !!skipped });
    if (splash.parentNode) splash.parentNode.removeChild(splash);
  }

  /* Skip on subsequent visits in this session OR for reduced-motion users. */
  var seen = false;
  try { seen = sessionStorage.getItem('tpl-splash-seen') === '1'; } catch (e) {}
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Perf 2026-08-28: also skip on constrained connections (Save-Data, 2G/3G).
     The splash is ~4s of DOM churn that holds the hero back on exactly the
     devices that can least afford it. Wi-Fi / 4G / unknown keep the full show. */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var constrained = !!(conn && (conn.saveData || /(^|-)2g$|^3g$/.test(String(conn.effectiveType || ''))));
  if (seen || reduced || constrained) { dismissImmediate(true); return; }

  /* Need the tower data — fall back to a clean dismiss if it's missing. */
  var TOWER = window.TPL_TOWER;
  if (!TOWER || !TOWER.lines || !TOWER.cols) { dismissImmediate(true); return; }

  var CYCLE = '±∑¬ΩΣ@#X2M0W7BR4&%*?'.split('');

  /* Perf 2026-08-31: mobile "lite" mode. Same choreography (lock cadence,
     beams, sparks, duration all unchanged) but the random glyph churn runs at
     roughly a third of the DOM writes: the tower is 7.5px type on phones, so
     the extra noise density is invisible while the style/layout cost is not
     (~6s of main-thread on a 4x-throttled phone). Desktop keeps the full show. */
  var LITE = window.innerWidth < 750;
  var MSG_LINES = ['An archive for collectors.', 'Not shoppers.'];

  function ri(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function flattenCells(t) {
    var cells = [];
    for (var r = 0; r < t.lines.length; r++) {
      var parts = t.lines[r];
      var col = 0;
      for (var p = 0; p < parts.length; p++) {
        var tag = parts[p][0], txt = parts[p][1];
        for (var i = 0; i < txt.length; i++) {
          cells.push({ ch: txt.charAt(i), tag: tag, r: r, c: col });
          col++;
        }
      }
    }
    return cells;
  }

  var CELLS = flattenCells(TOWER);
  var GOLD_CELLS = CELLS.filter(function (c) { return c.tag === 'G'; });

  function Splash(el) {
    this.el = el;

    this.golds = GOLD_CELLS.map(function (c) {
      return { ch: c.ch, tag: c.tag, r: c.r, c: c.c, phase: Math.random() * Math.PI * 2 };
    });

    if (this.golds.length) {
      var minR = Infinity;
      for (var i = 0; i < this.golds.length; i++) if (this.golds[i].r < minR) minR = this.golds[i].r;
      var beacons = [];
      for (var j = 0; j < this.golds.length; j++) {
        this.golds[j].isBeacon = this.golds[j].r <= minR + 1;
        if (this.golds[j].isBeacon) beacons.push(this.golds[j]);
      }
      var sumC = 0, minBR = Infinity;
      for (var k = 0; k < beacons.length; k++) {
        sumC += beacons[k].c;
        if (beacons[k].r < minBR) minBR = beacons[k].r;
      }
      this.beaconC = sumC / beacons.length;
      this.beaconR = minBR;
      var self = this;
      this.beaconCell = beacons.reduce(function (best, c) {
        if (!best) return c;
        var s = function (cell) { return -cell.r * 100 + Math.abs(cell.c - self.beaconC); };
        return s(c) < s(best) ? c : best;
      }, null);
    } else {
      this.beaconC = TOWER.cols / 2;
      this.beaconR = 4;
      this.beaconCell = null;
    }

    this.print     = el.querySelector('.splash__print');
    this.brandEl   = el.querySelector('.splash__brand');
    this.copy      = el.querySelector('.splash__copy');
    this.copyText  = el.querySelector('.splash__copy .text');
    this.caret     = el.querySelector('.splash__copy .caret');
    this.scanlines = el.querySelector('.scanlines');
    this.flash     = el.querySelector('.glitch-flash');
    this.cornerBL  = el.querySelector('.chrome .bl');
    this.cornerBR  = el.querySelector('.chrome .br');
    this.beams     = Array.prototype.slice.call(el.querySelectorAll('.splash__beam'));

    this.timers = []; this.intervals = []; this.rafs = [];
    this.cellEls = null;
    this.alive = false;
  }

  Splash.prototype.cancel = function () {
    for (var i = 0; i < this.timers.length; i++) clearTimeout(this.timers[i]);
    for (var j = 0; j < this.intervals.length; j++) clearInterval(this.intervals[j]);
    for (var k = 0; k < this.rafs.length; k++) cancelAnimationFrame(this.rafs[k]);
    this.timers = []; this.intervals = []; this.rafs = [];
    this.alive = false;
  };
  Splash.prototype.later = function (ms, fn) { this.timers.push(setTimeout(fn, ms)); };

  Splash.prototype.buildPrint = function () {
    this.cellEls = [];
    for (var r = 0; r < TOWER.rows; r++) {
      this.cellEls[r] = new Array(TOWER.cols);
    }
    var html = '';
    for (var rr = 0; rr < TOWER.rows; rr++) {
      html += '<span class="row-r" data-row="' + rr + '">';
      for (var i = 0; i < CELLS.length; i++) {
        var cell = CELLS[i];
        if (cell.r !== rr) continue;
        if (cell.ch === ' ') {
          html += ' ';
        } else {
          var cls = cell.tag === 'G' ? 'cell-gold' : 'cell-base';
          var safe = cell.ch === '<' ? '&lt;' : (cell.ch === '>' ? '&gt;' : (cell.ch === '&' ? '&amp;' : cell.ch));
          html += '<span class="' + cls + '" data-r="' + rr + '" data-c="' + cell.c + '">' + safe + '</span>';
        }
      }
      html += '</span>';
    }
    this.print.innerHTML = html;
    var spans = this.print.querySelectorAll('[data-r]');
    for (var s = 0; s < spans.length; s++) {
      var span = spans[s];
      this.cellEls[+span.getAttribute('data-r')][+span.getAttribute('data-c')] = span;
    }
  };

  Splash.prototype.runGlitch = function (onDone) {
    var self = this;
    var rowsLocked = new Array(TOWER.rows);
    for (var i = 0; i < TOWER.rows; i++) rowsLocked[i] = false;
    var lockBatch = 4, batchEvery = 38, cycleEvery = LITE ? 50 : 38, lockStartAt = 180;
    var cursor = lockStartAt;

    for (var r = 0; r < TOWER.rows; r += lockBatch) {
      var batchRows = [];
      for (var k = 0; k < lockBatch && r + k < TOWER.rows; k++) batchRows.push(r + k);
      (function (rows, at) {
        self.later(at, function () {
          for (var x = 0; x < rows.length; x++) {
            var rr = rows[x];
            rowsLocked[rr] = true;
            for (var cc = 0; cc < TOWER.cols; cc++) {
              var span = self.cellEls[rr][cc];
              if (!span) continue;
              for (var y = 0; y < CELLS.length; y++) {
                var cell = CELLS[y];
                if (cell.r === rr && cell.c === cc) {
                  span.textContent = cell.ch;
                  break;
                }
              }
            }
          }
        });
      })(batchRows, cursor);
      cursor += batchEvery;
    }
    var lockDoneAt = cursor;
    var t0 = performance.now();

    var tickIv = setInterval(function () {
      var now = performance.now() - t0;
      if (now > lockDoneAt) {
        clearInterval(tickIv);
        self.later(0, function () { if (onDone) onDone(); });
        return;
      }
      for (var rr = 0; rr < TOWER.rows; rr++) {
        if (rowsLocked[rr]) continue;
        for (var cc = 0; cc < TOWER.cols; cc++) {
          var span = self.cellEls[rr][cc];
          if (!span) continue;
          if (Math.random() < (LITE ? 0.32 : 0.7)) span.textContent = ri(CYCLE);
        }
      }
    }, cycleEvery);
    this.intervals.push(tickIv);

    [200, 500, 800].forEach(function (at) {
      self.later(at, function () {
        self.print.classList.add('aberration');
        self.print.classList.add(Math.random() < 0.5 ? 'shift' : 'shift-neg');
        if (self.flash) {
          /* cached in init() — no layout read inside the run */
          self.flash.style.transition = 'opacity 50ms ease';
          self.flash.style.top = (Math.random() * 0.6 + 0.2) * (self.stageH || 0) + 'px';
          self.flash.style.opacity = '0.9';
          self.later(90, function () { self.flash.style.opacity = '0'; });
        }
        self.later(110, function () {
          self.print.classList.remove('aberration', 'shift', 'shift-neg');
        });
      });
    });
    this.later(60, function () { self.scanlines.style.opacity = '1'; });
    this.later(lockDoneAt + 80, function () { self.scanlines.style.opacity = '0.30'; });
    return lockDoneAt;
  };

  /* Perf 2026-10-03 (MotionScore: the splash's own frames were the last
     thrashing source on desktop). positionBeams used to measure, write the two
     beams, and then runTowerLoop measured the stage and four more elements —
     a forced layout right after the write. measureStage() now takes every
     geometry read the splash will ever need, in one pass, and applyStage()
     does every write after it. Nothing reads layout again for the rest of the
     ~6s run. */
  Splash.prototype.measureStage = function () {
    var m = { ok: false, illum: [] };
    var beaconSpan = this.beaconCell ? this.cellEls[this.beaconCell.r][this.beaconCell.c] : null;
    if (!beaconSpan) return m;
    /* READS — all of them, back to back */
    var stageRect = this.el.getBoundingClientRect();
    var bRect = beaconSpan.getBoundingClientRect();
    var els = [this.brandEl, this.copy, this.cornerBL, this.cornerBR];
    var rects = new Array(els.length);
    for (var i = 0; i < els.length; i++) rects[i] = els[i] ? els[i].getBoundingClientRect() : null;
    /* derive */
    m.ok = true;
    m.beaconX = bRect.left - stageRect.left + bRect.width / 2;
    m.beaconY = bRect.top - stageRect.top + bRect.height / 2;
    for (var j = 0; j < els.length; j++) {
      if (!els[j] || !rects[j]) continue;
      m.illum.push({
        el: els[j],
        cx: rects[j].left + rects[j].width / 2 - stageRect.left,
        cy: rects[j].top + rects[j].height / 2 - stageRect.top
      });
    }
    return m;
  };

  Splash.prototype.applyStage = function (m) {
    if (!m || !m.ok) return;
    this.beaconStageX = m.beaconX;
    this.beaconStageY = m.beaconY;
    /* WRITES */
    for (var i = 0; i < this.beams.length; i++) {
      this.beams[i].style.left = m.beaconX + 'px';
      this.beams[i].style.top = m.beaconY + 'px';
    }
    for (var u = 0; u < m.illum.length; u++) {
      m.illum[u].angle = Math.atan2(m.illum[u].cy - m.beaconY, m.illum[u].cx - m.beaconX);
    }
    this.illuminables = m.illum;
  };

  Splash.prototype.runTowerLoop = function () {
    if (this.alive) return;
    this.alive = true;
    var self = this;

    var golds = [];
    for (var i = 0; i < this.golds.length; i++) {
      var g = this.golds[i];
      var span = self.cellEls[g.r] && self.cellEls[g.r][g.c];
      if (span) golds.push({ r: g.r, c: g.c, phase: g.phase, span: span, isBeacon: g.isBeacon });
    }
    var startTs = performance.now();
    var sparks = [];
    var beaconSpan = this.beaconCell ? this.cellEls[this.beaconCell.r][this.beaconCell.c] : null;

    var sparkIv = setInterval(function () {
      if (!self.alive) return;
      var g = golds[Math.floor(Math.random() * golds.length)];
      if (!g || !g.span) return;
      sparks.push({ span: g.span, prevClass: g.span.className, untilTs: performance.now() + 130 });
      g.span.className = 'cell-spark';
    }, 130);
    this.intervals.push(sparkIv);

    /* Measured once by measureStage(); no layout reads here. */
    var illuminables = this.illuminables || [];

    var period = 3500;
    var beamOffsets = [0, Math.PI];
    var beamWidth = Math.PI / 14;

    var liteFrame = 0;
    var tick = function () {
      if (!self.alive) return;
      /* lite: run the per-cell shimmer at 30fps; beams still update every frame below */
      if (LITE && (liteFrame++ % 2)) { self.rafs.push(requestAnimationFrame(tick)); return; }
      var t = performance.now() - startTs;

      for (var i = sparks.length - 1; i >= 0; i--) {
        if (performance.now() > sparks[i].untilTs) {
          sparks[i].span.className = sparks[i].prevClass || 'cell-gold';
          sparks.splice(i, 1);
        }
      }

      for (var gi = 0; gi < golds.length; gi++) {
        var gg = golds[gi];
        if (gg.span.className === 'cell-spark') continue;
        if (gg.span === beaconSpan) continue;
        var v = 0.5 + 0.5 * Math.sin(t * 0.0028 + gg.phase);
        var cls = 'cell-gold';
        if (v < 0.30) cls = 'cell-gold-dim';
        var wasLit = gg.span.classList.contains('lit');
        if (gg.span.className.split(' ')[0] !== cls) gg.span.className = cls + (wasLit ? ' lit' : '');
      }

      if (beaconSpan) {
        var b = 0.5 + 0.5 * Math.sin(t * 0.005);
        if (beaconSpan.className.indexOf('cell-beacon') !== 0) beaconSpan.className = 'cell-beacon';
        beaconSpan.style.opacity = (0.55 + b * 0.45).toFixed(2);
      }

      var baseAngle = (t / period) * Math.PI * 2;
      var activeAngles = [baseAngle + beamOffsets[0], baseAngle + beamOffsets[1]];
      var inBeam = function (angle) {
        for (var ba = 0; ba < activeAngles.length; ba++) {
          var diff = ((angle - activeAngles[ba] + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
          if (Math.abs(diff) < beamWidth) return true;
        }
        return false;
      };

      /* Drive beam rotation from JS so the visual beam stays in sync
         with the LIT-cell math above. (CSS keyframe animation didn't
         apply reliably across all rendering contexts.) */
      var degA = activeAngles[0] * 180 / Math.PI;
      var degB = activeAngles[1] * 180 / Math.PI;
      if (self.beams[0]) self.beams[0].style.transform = 'translateY(-50%) rotate(' + degA + 'deg)';
      if (self.beams[1]) self.beams[1].style.transform = 'translateY(-50%) rotate(' + degB + 'deg)';

      for (var gh = 0; gh < golds.length; gh++) {
        var gx = golds[gh];
        var dx = gx.c - self.beaconC;
        var dy = gx.r - self.beaconR;
        if (Math.sqrt(dx * dx + dy * dy) < 1) continue;
        var ang = Math.atan2(dy, dx);
        var lit = inBeam(ang);
        if (lit && !gx.span.classList.contains('lit')) gx.span.classList.add('lit');
        else if (!lit && gx.span.classList.contains('lit')) gx.span.classList.remove('lit');
      }

      for (var ii = 0; ii < illuminables.length; ii++) {
        var oo = illuminables[ii];
        var olit = inBeam(oo.angle);
        if (olit && !oo.el.classList.contains('lit')) oo.el.classList.add('lit');
        else if (!olit && oo.el.classList.contains('lit')) oo.el.classList.remove('lit');
      }

      self.rafs.push(requestAnimationFrame(tick));
    };
    this.rafs.push(requestAnimationFrame(tick));
  };

  Splash.prototype.scheduleBrand = function (brandStart) {
    var self = this;
    this.later(brandStart, function () { self.brandEl.style.opacity = '1'; });
    return brandStart + 500;
  };
  Splash.prototype.scheduleTypewriter = function (typeStart) {
    var self = this;
    var clock = typeStart;
    var acc = ['', ''];
    MSG_LINES.forEach(function (line, li) {
      line.split('').forEach(function (c) {
        var at = clock;
        self.later(at, function () {
          acc[li] += c;
          self.copyText.textContent = acc.filter(Boolean).join('\n');
        });
        clock += 22 + (c === '.' ? 130 : c === ',' ? 80 : 0);
      });
      clock += 150;
    });
    this.later(typeStart, function () {
      self.caret.style.opacity = '1';
      self.caret.style.animation = 'tpl-splash-blink 0.95s step-end infinite';
    });
    return clock;
  };
  Splash.prototype.scheduleChrome = function (start) {
    var self = this;
    var corners = this.el.querySelectorAll('.chrome .corner');
    for (var i = 0; i < corners.length; i++) {
      (function (c, idx) {
        self.later(start + idx * 120, function () { c.style.opacity = '1'; });
      })(corners[i], i);
    }
  };

  Splash.prototype.dismiss = function () {
    var self = this;
    window.tplSplash.done = true;
    try { sessionStorage.setItem('tpl-splash-seen', '1'); } catch (e) {}
    dispatchDone({ skipped: false });
    /* Stop rAF/intervals/timers IMMEDIATELY so the loop doesn't keep
       pushing new frames during the exit. Use a raw setTimeout for the DOM
       removal since cancel() just cleared this.timers. */
    self.cancel();
    /* Line-reveal exit (motion.dev "Loading overlay", 2026-09-08): a hairline
       draws across the middle, then the panel splits along it and the two
       halves slide away to reveal the page. Falls back to the CSS fade. */
    var canAnimate = typeof self.el.animate === 'function';
    if (!canAnimate) {
      self.el.classList.add('fading');
      setTimeout(function () { if (self.el.parentNode) self.el.parentNode.removeChild(self.el); }, 400);
      return;
    }
    var line = document.createElement('div');
    line.className = 'splash__exit-line';
    self.el.appendChild(line);
    self.el.classList.add('exiting');
    line.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: 520, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' });
    setTimeout(function () {
      line.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, delay: 250, fill: 'forwards' });
      var split = self.el.animate(
        [{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(50% 0 50% 0)' }],
        { duration: 620, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
      );
      split.onfinish = function () { if (self.el.parentNode) self.el.parentNode.removeChild(self.el); };
    }, 560);
    setTimeout(function () { if (self.el.parentNode) self.el.parentNode.removeChild(self.el); }, 1500);
  };

  Splash.prototype.init = function () {
    var self = this;
    this.cancel();

    /* Perf 2026-10-03: the stage height is read exactly once, here, before the
       first style write of the run. The glitch flash used to re-read
       offsetHeight at 200/500/800ms, each time right after other elements had
       been written — three forced layouts the audit attributed to
       "scanlines opacity → #tpl-splash offsetHeight". The stage cannot change
       height mid-splash, so one read serves all of them. */
    this.stageH = this.el.offsetHeight;

    this.brandEl.style.opacity = '0';
    this.brandEl.classList.remove('lit');
    this.copyText.textContent = '';
    this.caret.style.opacity = '0';
    this.caret.style.animation = 'none';
    this.copy.classList.remove('lit');
    this.scanlines.style.opacity = '0';
    this.flash.style.opacity = '0';
    this.el.classList.remove('fading', 'beams-on');
    var corners = this.el.querySelectorAll('.chrome .corner');
    for (var i = 0; i < corners.length; i++) {
      corners[i].style.opacity = '0';
      corners[i].classList.remove('lit');
    }
    if (this.print) this.print.classList.remove('breathing', 'aberration', 'shift', 'shift-neg');

    this.buildPrint();
    var spans = this.print.querySelectorAll('[data-r]');
    for (var j = 0; j < spans.length; j++) spans[j].textContent = ri(CYCLE);

    this.runGlitch(function () {
      /* measureStage + applyStage FIRST — runTowerLoop needs beaconStageX/Y
         and this.illuminables. If those are still undefined (which they are
         until applyStage runs), the angles come out NaN and the text never
         lights up. */
      requestAnimationFrame(function () {
        self.applyStage(self.measureStage());
        self.runTowerLoop();
        self.el.classList.add('beams-on');
      });
    });

    var brandStart = 900;
    var brandDone = this.scheduleBrand(brandStart);
    this.scheduleTypewriter(brandDone + 100);
    this.scheduleChrome(brandStart + 200);
    this.later(brandDone + 400, function () { self.print.classList.add('breathing'); });

    this.later(3500, function () { self.dismiss(); });
  };

  function start() {
    var s = new Splash(splash);
    s.init();
  }

  /* Start immediately — don't await document.fonts.ready. All four brand
     woff2 files have <link rel=preload> + font-display:swap, so the splash
     paints in the system fallback (SF / SF Mono on iOS, Helvetica / Consolas
     on Android) and the real fonts swap in mid-animation a beat later.
     Awaiting fonts.ready added 1–4s of pure white on slow mobile networks. */
  start();
})();
